import enUS from 'antd/es/locale/en_US'
export default {
    ...enUS,
    label: 'English',
    value: 'en',

    // 菜单标题
    overview: 'Overview',
    incomeStatistic: 'Revenue Statistics',
    incomeRecord: "Revenue Flow",
    paymentStatistic: 'Reporting Statistics',
    lowerPaymentStatistic: 'Downline Reporting Statistics',
    gameStatistic: 'Game Statistics',
    integralStatistic: 'Points Consumption Statistics',
    diamondManage: 'Diamonds Manage',
    diamondStatistic: 'Diamonds Statistics',
    diamondOpeningStartStatistic: 'Diamonds Game Start Consumption Statistics',
    diamondExchangeIntegralStatistic: 'Diamonds Exchange Points Statistics',
    diamondDistributionStatistic: 'Diamonds Distribution Statistics',
    diamondRecord: 'Diamonds Transaction Flow',
    proxyList: 'Agent Management',
    proxyDetail: 'Agent Details',
    proxyStatistic: 'Agent Statistics',
    gamblingRecord: 'Game Round Transaction Flow',
    betRecord: 'Bet Slip Transaction Flow',
    integralRecord: 'Integral Records',
    propsConsumeRecord: 'Item Consumption Transaction Flow',
    activityManage: 'Event Management',
    activityLuckyCard: 'LuckyCard',
    activityLuckyCardRecord: 'LuckyCard Hit Records',
    activityLuckyCardRewardReview: 'LuckyCard Reward Review',
    activityBadBeatJackpot: 'BadBeatJackpot',
    activityBadBeatJackpotRewardRecord: "BadBeatJackpot Reward Review",
    activityHighHandCard: 'HighHandCard',
    activityHandRank: 'Hand Count Ranking',
    dailyChallenge: 'Daily Challenge',
    dailyChallengeRecord: 'Daily Challenge Activity Record',
    dailyChallengeDetail: 'Daily Challenge Activity Details',
    activityPoster: 'Poster Management',
    unionManage: 'Sub-Alliance Management',
    unionList: 'Alliance List',
    unionDetail: 'Alliance Details',
    clubManage: 'Club Management',
    clubList: 'Club List',
    clubDetail: 'Club Details',
    playerManage: 'Player Management',
    playerList: 'Player List',
    playerStatistic: 'Player Statistics',
    playerDetail: 'Player Details',
    tableManage: 'Table Management',
    tableRoundList: 'Game Round List',
    tableConfigList: 'Configuration List',
    tableRoundRecordList: 'Game Round Records',
    tableConfigStatistic: 'Configuration Statistics',
    mttManage: 'MTT',
    mttCreate: 'MTT Creation',
    mttList: 'MTT List',
    mttRoundList: 'MTT Game Round List',
    mttTicket: 'Ticket',
    mttTicketList: 'Ticket List',
    mttDataStatistic: 'MTT Data Statistics',
    partnerManage: 'Collusion Management',
    partnerCardQuery: 'Collusion Query Tool',
    partnerCardStatistic: 'Suspected Collusion Statistics',
    derivativeDetection: 'Derivative Detection',
    gameCurrencyTypeProportion: 'Game Currency Types Proportion',
    integralProportion: 'Integral ratio',
    accountManage: 'Account Management',
    accountSetting: 'Account Settings',
    accountSwitch: 'Switch Account',

    // Message提示
    deleteSuccessMessage: 'Deleted successfully',
    addSuccessMessage: 'Added successfully',
    saveSuccessMessage: 'Saved successfully',
    updateSuccessMessage: 'Updated successfully',
    operationSuccessMessage: 'Operation successful',
    exportSuccessMessage: 'Exported successfully',
    importSuccessMessage: 'Imported successfully',
    createSuccessMessage: 'Created successfully',
    publishSuccessMessage: 'Published successfully',
    dissolveSuccessMessage: 'Dissolved successfully',
    batchDissolveSuccessMessage: 'Batch dissolved successfully',
    applySuccessMessage: 'Registered successfully',
    batchApplaySuccessMessage: 'Batch registered successfully',
    cancelApplySuccessMessage: 'Registration cancelled successfully',
    destroySuccessMessage: 'Unregistered successfully',
    giveSuccessMessage: 'Gifted successfully',
    setSuccessMessage: 'Settings saved successfully',
    finishSuccessMessage: 'Ended successfully',
    rechargeSuccessMessage: 'Top-up successful',
    editSuccessMessage: 'Edited successfully',
    offlineSuccessMessage: 'Taken offline successfully',
    agreeApplicationMessage: 'Application approved',
    refuseApplicationMessage: 'Application rejected',
    noDataMessage: 'No data available',
    matchEndMessage: 'Tournament has ended',
    intergralNotEnoughMessage: 'Sorry, counter points insufficient',
    uploadeTypeMessage: 'Only PNG/JPG/JPEG/GIF images allowed!',
    uploadeSizeMessage: 'Image size must not exceed 1MB!',
    insufficientPointsMessage: 'Sorry, counter points insufficient!',
    broughtRangeCannotConsistentMessage: 'Buy-in range must differ!',

    // Confirm确认框
    deleteAdminConfirm: 'Are you sure you want to add this admin account?',
    logoutConfirm: 'Are you sure you want to log out?',
    publishMatchConfirm: 'Are you sure you want to publish the event?',
    dissolveMatchConfirm: 'Are you sure you want to dissolve the event?',
    batchDissolveMatchConfirm: 'Are you sure you want to batch dissolve events?',
    destroyTicketConfirm: 'Are you sure you want to void the ticket?',
    deleteConfigConfirm: 'Are you sure you want to delete the config?',
    createGambleConfirm: 'Are you sure you want to create the game round?',
    finishGambleConfirm: 'Are you sure you want to end the game round?',
    rechargeIntegralConfirm: 'Are you sure to top up the prize pool with {} points?',
    publishPosterConfirm: 'Are you sure you want to publish the poster?',
    offlinePosterConfirm: 'Are you sure you want to take down the poster?',
    deletePosterConfirm: 'Are you sure you want to delete the poster?',
    offlineActivityConfirm: 'Are you sure you want to take down the event?',
    agreenClubApplyConfirm: 'Approve the club application?',
    refuseClubApplyConfirm: 'Reject the club application?',
    publishTaskConfirm: 'Are you sure you want to publish the task?',
    offlineTaskConfirm: 'Are you sure you want to take down the task?',
    reissueConfirm: 'Are you sure you want to reissue it?',
    noReissueConfirm: "Are you sure you won't reissue it?",
    publishConfirm: 'Are you sure you want to release it?',
    changePasswordConfirm: "Are you sure you want to change the password?",

    // 输入框
    phoneAccount: 'Phone Account',
    phoneAccountPlaceholder: 'Please enter phone account',
    phoneAccountVerify: 'Phone account cannot be empty!',
    emailAccount: 'Email Account',
    emailAccountPlaceholder: 'Please enter email account',
    emailAccountVerify: 'Email account cannot be empty!',
    account: "Account",
    accountPlaceholder: "Please enter account",
    accountVerify: "Account cannot be empty!",
    password: 'Password',
    passwordPlaceholder: 'Please enter password',
    passwordVerify: 'Password cannot be empty!',
    oldPassword: 'Original Password',
    oldPasswordPlaceholder: 'Please enter original password',
    oldPasswordVerify: 'Original password cannot be empty!',
    newPassword: 'New password',
    newPasswordPlaceholder: 'Please enter new password',
    newPasswordVerify: 'New password cannot be empty!',
    confrimPassword: 'Confirm password ',
    confrimPasswordPlaceholder: 'Please enter confirm password',
    confrimPasswordVerify: 'Confirm password cannot be empty!',
    confrimPasswordVerify2: "The passwords entered twice are inconsistent!",
    rechargeAmount: 'Top-up Amount',
    rechargeAmountPlaceholder: 'Please enter top-up amount',
    rechargeAmountVerify: 'Top-up amount cannot be empty!',
    roundBonus: 'Prize per round (Total: {})',
    roundBonusPlaceholder: 'Please enter prize per round',
    roundBonusVerify: 'Prize per round cannot be empty!',
    rankRewrad: 'Rank {}',
    rankRewradPlaceholder: 'Please enter prize for rank {}',
    rankRewradVerify: 'Prize for rank {} cannot be empty!',
    serviceProportion: 'Service Fee Ratio',
    serviceProportionPlaceholder: 'Please enter service fee ratio',
    serviceProportionVerify: 'Service fee ratio cannot be empty!',
    insuranceProportion: 'Insurance Ratio',
    insuranceProportionPlaceholder: 'Please enter insurance ratio',
    insuranceProportionVerify: 'Insurance ratio cannot be empty!',
    cowboyProportion: 'Cowboy Ratio',
    cowboyProportionPlaceholder: 'Please enter cowboy ratio',
    cowboyProportionVerify: 'Cowboy ratio cannot be empty!',
    gambleName: 'Game Round Name',
    gambleNamePlaceholder: 'Please enter game round name',
    gambleNameVerify: 'Game round name cannot be empty!',
    minEmptyTable: 'Minimum Empty Table Count',
    minEmptyTablePlaceholder: 'Please enter minimum empty table count',
    minEmptyTableVerify: 'Minimum empty table count cannot be empty!',
    matchName: 'Tournament Name',
    matchNamePlaceholder: 'Please enter tournament name',
    matchNameVerify: 'Tournament name cannot be empty!',
    matchDescription: 'Tournament Description',
    matchDescriptionPlaceholder: 'Please enter tournament description',
    matchDescriptionVerify: 'Tournament description cannot be empty!',
    prizePoolPlaceholder: 'Please enter guaranteed prize pool',
    prizePoolVerify: 'Guaranteed prize pool cannot be empty!',
    applyFee: 'Entry Fee',
    applyFeePlaceholder: 'Please enter entry fee',
    applyFeeVerify: 'Entry fee cannot be empty!',
    minStartMatchPeople: 'Minimum Start Players',
    minStartMatchPeoplePlaceholder: 'Please enter minimum start players',
    minStartMatchPeopleVerify: 'Minimum start players cannot be empty!',
    rebuyFee: 'Rebuy Fee',
    rebuyFeePlaceholder: 'Please enter rebuy fee',
    rebuyFeeVerify: 'Rebuy fee cannot be empty!',
    unionOwnerId: 'Alliance Owner ID',
    unionOwnerIdPlaceholder: 'Please enter alliance owner ID',
    unionOwnerIdVerify: 'Alliance owner ID cannot be empty!',
    unionName: 'Alliance Name',
    unionNamePlaceholder: 'Please enter alliance name',
    unionNameVerify: 'Alliance name cannot be empty!',
    clubId: 'Club ID',
    clubIdPlaceholder: 'Please enter club ID',
    clubIdVerify: 'Club ID cannot be empty!',
    clubName: 'Club Name',
    clubNamePlaceholder: 'Please enter club name',
    clubNameVerify: 'Club name cannot be empty!',
    playerId: 'Player ID',
    playerIdPlaceholder: 'Please enter player ID',
    playerIdVerify: 'Player ID cannot be empty!',
    playerName: 'Player Nickname',
    playerNamePlaceholder: 'Please enter player nickname',
    playerNameVerify: 'Player nickname cannot be empty!',
    matchId: 'Tournament ID',
    matchIdPlaceholder: 'Please enter tournament ID',
    matchIdVerify: 'Tournament ID cannot be empty!',
    uid: 'UID',
    uidPlaceholder: 'Please enter UID',
    uidVerify: 'UID cannot be empty!',
    satelliteMatchMid: 'Satellite Match MID',
    satelliteMatchMidPlaceholder: 'Please enter satellite match MID',
    satelliteMatchMidVerify: 'Satellite match MID cannot be empty!',
    palyerOneId: 'Player 1 ID',
    palyerOneIdPlaceholder: 'Please enter Player 1 ID',
    palyerOneIdVerify: 'Player 1 ID cannot be empty!',
    playerTwoId: 'Player 2 ID',
    playerTwoIdPlaceholder: 'Please enter Player 2 ID',
    playerTwoIdVerify: 'Player 2 ID cannot be empty!',
    searchContent: 'Search Content',
    searchContentPlaceholder: 'Please enter search content',
    searchContentVerify: 'Search content cannot be empty!',
    propCusomeProportion: 'Item Consumption Ratio',
    propCusomeProportionPlaceholder: 'Please enter item consumption ratio',
    propCusomeProportionVerify: 'Item consumption ratio cannot be empty!',
    memberId: 'Member ID',
    memberIdPlaceholder: 'Please enter member ID',
    memberIdVerify: 'Member ID cannot be empty!',
    proxyId: 'Agent ID',
    proxyIdPlaceholder: 'Please enter agent ID',
    proxyIdVerify: 'Agent ID cannot be empty!',
    proxyIdVerify1: 'Please enter 3 to 64 characters!',
    kpokerPlayerId: 'Kpoker Player ID',
    kpokerPlayerIdPlaceholder: 'Please enter Kpoker player ID',
    kpokerPlayerIdVerify: 'Kpoker player ID cannot be empty!',
    proxy: 'Agent',
    proxyPlaceholder: 'Please enter agent',
    proxyVerify: 'Agent cannot be empty!',
    proxyVerify1: 'Please enter 3 to 20 characters!',
    mainMatchMid: 'Main Event MID',
    mainMatchMidPlaceholder: 'Please enter Main Event MID',
    mainMatchMidVerify: 'Main Event MID cannot be empty!',
    accountId: 'Account ID',
    accountIdPlaceholder: 'Please enter account ID',
    accountIdVerify: 'Account ID cannot be empty!',
    superUnionId: 'Super Union ID',
    superUnionIdPlaceholder: 'Please enter Super Union ID',
    superUnionIdVerify: 'Super Union ID cannot be empty!',
    superUnionName: 'Super Union Name',
    superUnionNamePlaceholder: 'Please enter Super Union name',
    superUnionNameVerify: 'Super Unionname cannot be empty!',
    superUnionIntroduce: 'Super UnionIntroduction',
    superUnionIntroducePlaceholder: 'Please enter Super Union introduction (max 140 chars)',
    superUnionIntroduceVerify: 'Super Union introduction cannot be empty!',
    unionId: 'Alliance ID',
    unionIdPlaceholder: 'Please enter alliance ID',
    unionIdVerify: 'Alliance ID cannot be empty!',
    unionIntroduce: 'Alliance Introduction',
    unionIntroducePlaceholder: 'Please enter alliance introduction (max 140 chars)',
    unionIntroduceVerify: 'Alliance introduction cannot be empty!',
    gameId: 'Game ID',
    gameIdPlaceholder: 'Please enter Game ID',
    gameIdVerify: 'Game ID cannot be empty!',
    gameAccount: 'Game Account',
    gameAccountPlaceholder: 'Please enter game account',
    gameAccountVerify: 'Game account cannot be empty!',
    publishMatchTime: 'How long before start to publish',
    publishMatchTimePlaceholder: 'Please enter how long before start to publish',
    publishMatchTimeVerify: 'This field cannot be empty!',
    addonFee: 'Addon Fee',
    addonFeePlaceholder: 'Please enter Addon fee',
    addonFeeVerify: 'Addon fee cannot be empty!',
    minTicket: 'Guaranteed Ticket',
    minTicketPlaceholder: 'Please enter guaranteed ticket',
    minTicketVerify: 'Guaranteed ticket cannot be empty!',
    minPrizePool: 'Guaranteed Prize Pool',
    minPrizePoolPlaceholder: 'Please enter guaranteed prize pool',
    minPrizePoolVerify: 'Guaranteed prize pool cannot be empty!',
    batchApplyPeople: 'Batch Registration Count',
    batchApplyPeoplePlaceholder: 'Please enter batch registration count!',
    batchApplyPeopleVerify: 'Batch registration count cannot be empty!',
    winnerProportion: 'Winner Ratio',
    winnerProportionPlaceholder: 'Please enter winner ratio',
    winnerProportionVerify: 'Winner ratio cannot be empty!',
    loserProportion: 'Loser Ratio',
    loserProportionPlaceholder: 'Please enter loser ratio',
    loserProportionVerify: 'Loser ratio cannot be empty!',
    amount: 'Quantity',
    amountPlaceholder: 'Please enter quantity',
    amountVerify: 'Quantity cannot be empty!',
    ipWhiteList: 'IP Whitelist',
    ipWhiteListPlaceholder: 'Please enter IP whitelist',
    ipWhiteListVerify: 'IP whitelist cannot be empty!',
    proxyAccount: 'Agent back-end account',
    proxyAccountPlaceholder: 'Please enter agent back-end account',
    proxyAccountVerify: 'Agent back-end account cannot be empty!',
    proxyAccountVerify1: 'Please enter 4 to 16 digits or letters!',
    startPage: 'Start Page',
    startPagePlaceholder: 'Please enter start page',
    startPageVerify: 'Start page cannot be empty!',
    endPage: 'End Page',
    endPagePlaceholder: 'Please enter end page',
    endPageVerify: 'End page cannot be empty!',
    bonus: 'Bonus',
    bonusPlaceholder: 'Please enter bonus',
    bonusVerify: 'Bonus cannot be empty!',
    integral: 'Integral',
    integralPlaceholder: 'Please enter integral',
    integralVerify: 'Integral cannot be empty!',
    diamond: 'Diamond',
    diamondPlaceholder: 'Please enter diamond',
    diamondVerify: 'Diamond cannot be empty!',
    ticketId: 'Ticket id',
    ticketIdPlaceholder: 'Please enter ticket id',
    ticketIdVerify: 'Ticket id cannot be empty!',
    ticketName: 'Ticket name',
    ticketNamePlaceholder: 'Please enter ticket name',
    ticketNameVerify: 'Ticket name cannot be empty!',
    ticketValue: 'Ticket value',
    ticketValuePlaceholder: 'Please enter ticket value',
    ticketValueVerify: 'Ticket value cannot be empty!',
    taskName: 'Task name',
    taskNamePlaceholder: 'Please enter task name',
    taskNameVerify: 'Task name cannot be empty!',
    taskSort: 'Task sorting',
    taskSortPlaceholder: 'Please enter task sorting',
    taskSortVerify: 'Task sorting cannot be empty!',
    posterSort: 'Poster sorting',
    posterSortPlaceholder: 'Please enter poster sorting',
    posterSortVerify: 'Please enter poster sorting!',
    posterLinkUrl: 'Poster Link URL',
    posterLinkUrlPlaceholder: 'Please enter poster link URL',
    posterLinkUrlVerify: 'Link URL cannot be empty!',
    ticketAmount: 'Tickets Number',
    ticketAmountPlaceholder: 'Please enter the number of tickets',
    ticketAmountVerify: 'The number of tickets cannot be left empty!',
    playBoradHandNumber: 'Number of hands in a card game',
    playBoradHandNumberPlaceholder: 'Please enter the number of hands you play',
    playBoradHandNumberVerify: 'The number of hands in a card game cannot be empty!',
    hitCount: 'Hit Count',
    hitCountPlaceholder: 'Please enter the hit Count',
    hitCountVerify: 'The hit Count cannot be empty!',
    proportion: 'proportion',
    proportionPlaceholder: 'Please enter the proportion',
    proportionVerify: 'The proportion cannot be empty!',
    proportionVerify1: 'The proportion must be greater than 0!',
    usdt: 'USDT',
    uPlaceholder: 'Please enter U',
    uVerify: 'U cannot be empty!',
    uVerify1: 'U must be greater than 0!',
    taskId: 'Task ID',
    taskIdPlaceholder: 'Please enter the Task ID',
    taskIdVerify: 'The Task ID cannot be empty!',
    derivativeInitiatorOrReceiverId: 'Reverse Scoring Initiator or Receiver ID',
    derivativeInitiatorOrReceiverIdPlaceholder: 'Please enter the Reverse Scoring Initiator or Receiver ID',
    derivativeInitiatorOrReceiverIdVerify: 'Reverse Scoring Initiator or Receiver ID cannot be empty!',
    derivativeInitiatorId: 'Reverse Scoring Initiator ID',
    derivativeInitiatorIdPlaceholder: 'Please enter the Reverse Scoring Initiator ID',
    derivativeInitiatorIdVerify: 'Reverse Scoring Initiator ID cannot be empty!',
    derivativeReceiverId: 'Reverse Scoring Receiver ID',
    derivativeReceiverIdPlaceholder: 'Please enter the Reverse Scoring Receiver ID',
    derivativeReceiverIdVerify: 'Reverse Scoring Receiver ID cannot be empty!',
    dayLossLimit: 'Daily Loss Limit',
    dayLossLimitPlaceholder: 'Please enter the Daily Loss Limit',
    dayLossLimitVerify: 'Daily Loss Limit cannot be empty!',
    dayLossLimitQuota: 'Daily Loss Limit Quota',
    dayLossLimitQuotaPlaceholder: 'Please enter the Daily Loss Limit Quota',
    dayLossLimitQuotaVerify: 'Daily Loss Limit Quota cannot be empty!',
    dayRemainingRuota: 'Daily remaining quota',
    dayRemainingRuotaPlaceholder: 'Please enter the Daily remaining quota',
    dayRemainingRuotaVerify: 'Daily remaining quota cannot be empty!',
    weekLossLimit: 'Weekly Loss Limit',
    weekLossLimitPlaceholder: 'Please enter the Weekly Loss Limit',
    weekLossLimitVerify: 'Weekly Loss Limit cannot be empty!',
    weekLossLimitRuota: 'Weekly Loss Limit Quota',
    weekLossLimitRuotaPlaceholder: 'Please enter the Weekly Loss Limit Quota',
    weekLossLimitRuotaVerify: 'Weekly Loss Limit Quota cannot be empty!',
    weekRemainingRuota: 'Weekly remaining quota',
    weekRemainingRuotaPlaceholder: 'Please enter the Weekly remaining quota',
    weekRemainingRuotaVerify: 'Weekly remaining quota cannot be empty!',

    // 下拉框
    unionAccount: 'Super Union / Alliance Account',
    unionAccountPlaceholder: 'Please select Super Union / Alliance account',
    unionAccountVerify: 'Please select Super Union / Alliance account!',
    roundTime: 'Duration per Round',
    roundTimePlaceholder: 'Please select duration per round',
    roundTimeVerify: 'Please select duration per round!',
    roundAmount: 'Number of Rounds',
    roundAmountPlaceholder: 'Please select number of rounds',
    roundAmountVerify: 'Please select number of rounds!',
    startTime: 'Start Time',
    startTimePlaceholder: 'Please select start time',
    startTimeVerify: 'Please select start time!',
    timeRange: 'Time Range',
    timeRangePlaceholder: 'Please select time range',
    timeRangeVerify: 'Please select time range!',
    posterImage: 'Poster Image',
    posterImagePlaceholder: 'Please select poster image',
    posterImageVerify: 'Please select poster image!',
    insuranceDivide: 'Insurance Share Ratio',
    insuranceDividePlaceholder: 'Please select insurance share ratio',
    insuranceDivideVerify: 'Please select insurance share ratio!',
    cowboyDivide: 'Cowboy Share Ratio',
    cowboyDividePlaceholder: 'Please select cowboy share ratio',
    cowboyDivideVerify: 'Please select cowboy share ratio!',
    realTimeRecord: 'Real-time Results',
    realTimeRecordPlaceholder: 'Please select real-time results',
    realTimeRecordVerify: 'Please select real-time results!',
    levelRange: 'Level Range',
    levelRangePlaceholder: 'Please select level range',
    levelRangeVerify: 'Please select level range!',
    foreword: 'Ante',
    forewordPlaceholder: 'Please select ante',
    forewordVerify: 'Please select ante!',
    forewordRange: 'Ante Rang',
    forewordRangePlaceholder: 'Please select the ante range!',
    forewordRangeVerify: 'Please select the ante range!',
    bringRange: 'Buy-in Range',
    bringRangePlaceholder: 'Please select buy-in range',
    bringRangeVerify: 'Please select buy-in range!',
    serviceFee: 'Service Fee',
    serviceFeePlaceholder: 'Please select service fee',
    serviceFeeVerify: 'Please select service fee!',
    serviceFeeCap: 'Service Fee Cap',
    serviceFeeCapPlaceholder: 'Please select service fee cap',
    serviceFeeCapVerify: 'Please select service fee cap!',
    thinkTime: 'Thinking Time',
    thinkTimePlaceholder: 'Please select thinking time',
    thinkTimeVerify: 'Please select thinking time!',
    delayTime: 'Auto Extension Count',
    delayTimePlaceholder: 'Please select auto extension count',
    delayTimeVerify: 'Please select auto extension count!',
    peopleNumber: 'Player Count',
    peopleNumberPlaceholder: 'Please select player count',
    peopleNumberVerify: 'Please select player count!',
    time: 'Time',
    timePlaceholder: 'Please select time',
    timeVerify: 'Please select time!',
    gameMode: 'Game Mode',
    gameModePlaceholder: 'Please select game mode',
    gameModeVerify: 'Please select game mode!',
    operationOrder: 'Operation Order',
    operationOrderPlaceholder: 'Please select operation order',
    operationOrderVerify: 'Please select operation order!',
    multiple: 'Multiplier',
    multiplePlaceholder: 'Please select multiplier',
    multipleVerify: 'Please select multiplier!',
    multipleRange: 'Multiple Range',
    multipleRangePlaceholder: 'Please select multiple range',
    multipleRangeVerify: 'Please select multiple range!',
    minEntryPoint: 'Minimum Entry',
    minEntryPointPlaceholder: 'Please select minimum entry',
    minEntryPointVerify: 'Please select minimum entry!',
    blindType: 'Blind Structure',
    blindTypePlaceholder: 'Please select blind structure',
    blindTypeVerify: 'Please select blind structure!',
    rebuyTime: 'Rebuy Count',
    rebuyTimePlaceholder: 'Please select rebuy count',
    rebuyTimeVerify: 'Please select rebuy count!',
    rebuyChip: 'Rebuy Chips',
    rebuyChipPlaceholder: 'Please select rebuy chips',
    rebuyChipVerify: 'Please select rebuy chips!',
    initChip: 'Starting Chips',
    initChipPlaceholder: 'Please select starting chips',
    initChipVerify: 'Please select starting chips!',
    blindTimeApplyStart: 'Blind Increase Time (Before Registration Ends)',
    blindTimeApplyStartPlaceholder: 'Please select blind increase time',
    blindTimeApplyStartVerify: 'Please select blind increase time!',
    blindTimeApplyEnd: 'Blind Increase Time (After Registration)',
    blindTimeApplyEndPlaceholder: 'Please select blind increase time',
    blindTimeApplyEndVerify: 'Please select blind increase time!',
    blindTimeFinally: 'Blind Increase Time (Final Table)',
    blindTimeFinallyPlaceholder: 'Please select blind increase time',
    blindTimeFinallyVerify: 'Please select blind increase time!',
    deadlineApply: 'Registration Deadline',
    deadlineApplyPlaceholder: 'Please select registration deadline',
    deadlineApplyVerify: 'Please select registration deadline!',
    singleSeatNumber: 'Seats per Table',
    singleSeatNumberPlaceholder: 'Please select seats per table',
    singleSeatNumberVerify: 'Please select seats per table!',
    prizPooAllocation: 'Prize Pool Allocation',
    prizPooAllocationPlaceholder: 'Please select prize pool allocation',
    prizPooAllocationVerify: 'Please select prize pool allocation!',
    publishType: 'Publish Type',
    publishTypePlaceholder: 'Please select publish type',
    publishTypeVerify: 'Please select publish type!',
    startMatchTime: 'Start Time',
    startMatchTimePlaceholder: 'Please select start time',
    startMatchTimeVerify: 'Please select start time!',
    startMatchTimeRange: 'Tournament Date Range',
    startMatchTimeRangePlaceholder: 'Please select tournament date range',
    startMatchTimeRangeVerify: 'Please select tournament date range!',
    startMatchTimeWeek: 'Day of Week to Start',
    startMatchTimeWeekPlaceholder: 'Please select day of week to start',
    startMatchTimeWeekVerify: 'Please select day of week to start!',
    belongUnion: 'Belonging Alliance',
    belongUnionPlaceholder: 'Please select alliance',
    belongUnionVerify: 'Please select alliance!',
    belongClub: 'Belonging Club',
    belongClubPlaceholder: 'Please select club',
    belongClubVerify: 'Please select club!',
    role: 'Role',
    rolePlaceholder: 'Please select role',
    roleVerify: 'Please select role!',
    gameType: 'Game Type',
    gameTypePlaceholder: 'Please select game type',
    gameTypeVerify: 'Please select game type!',
    playingType: 'playing method',
    playingTypePlaceholder: 'Please select the gameplay',
    playingTypeVerify: 'Please select the gameplay!',
    sort: 'Sorting',
    sortPlaceholder: 'Please select sorting',
    sortVerify: 'Please select sorting!',
    searchType: 'Search Type',
    searchTypePlaceholder: 'Please select search type',
    searchTypeVerify: 'Please select search type!',
    blindLevel: 'Blind Level',
    blindLevelPlaceholder: 'Please select blind level',
    blindLevelVerify: 'Please select blind level!',
    belongGamble: 'Game Round Ownership',
    belongGamblePlaceholder: 'Please select game round ownership',
    belongGambleVerify: 'Please select game round ownership!',
    matchStatus: 'Tournament Status',
    matchStatusPlaceholder: 'Please select tournament status',
    matchStatusVerify: 'Please select tournament status!',
    unionPlaceholder: 'Please select alliance',
    unionVerify: 'Please select alliance!',
    status: 'Status',
    statusPlaceholder: 'Please select status',
    statusVerify: 'Please select status!',
    bonusStatus: "Bonus Status",
    bonusStatusPlaceholder: "Please select Bonus Status",
    bonusStatusVerify: "Please select Bonus Status!",
    squidValue: 'Squid Value',
    squidValuePlaceholder: 'Please select squid value',
    squidValueVerify: 'Please select squid value!',
    squidMode: 'Squid Mode',
    squidModePlaceholder: 'Please select squid mode',
    squidModeVerify: 'Please select squid mode!',
    detectionHandNumber: 'Hands Count to Start Detection',
    detectionHandNumberPlaceholder: 'Please select hands count to start detection',
    detectionHandNumberVerify: 'Please select hands count to start detection!',
    currentEntryPoolStandard: 'Entry Criteria for Current Round',
    currentEntryPoolStandardPlaceholder: 'Please select entry criteria',
    currentEntryPoolStandardVerify: 'Please select entry criteria!',
    sitEntryPoolRate: 'Sit-In Entry Rate',
    sitEntryPoolRatePlaceholder: 'Please select sit-in entry rate',
    sitEntryPoolRateVerify: 'Please select sit-in entry rate!',
    leaveCondition: 'Leave Condition',
    leaveConditionPlaceholder: 'Please select leave condition',
    leaveConditionVerify: 'Please select leave condition!',
    boomType: 'Bomb Type',
    boomTypePlaceholder: 'Please select bomb type',
    boomTypeVerify: 'Please select bomb type!',
    boomRandomPoolBetRange: 'Bomb Pool Random Ante Range',
    boomRandomPoolBetRangePlaceholder: 'Please select bomb pool ante range',
    boomRandomPoolBetRangeVerify: 'Please select bomb pool ante range!',
    triggerType: 'Trigger Type',
    triggerTypePlaceholder: 'Please select trigger type',
    triggerTypeVerify: 'Please select trigger type!',
    profitTrigger: 'Profit Trigger',
    profitTriggerPlaceholder: 'Please select profit trigger',
    profitTriggerVerify: 'Please select profit trigger!',
    lotteryPoolPrize: 'Jackpot Prize',
    lotteryPoolPrizePlaceholder: 'Please select jackpot prize',
    lotteryPoolPrizeVerify: 'Please select jackpot prize!',
    autoUnloadNumber: 'Auto Chip Removal Amount',
    autoUnloadNumberPlaceholder: 'Please select auto chip removal amount',
    autoUnloadNumberVerify: 'Please select auto chip removal amount!',
    autoStartPeople: 'Auto Start Player Count',
    autoStartPeoplePlaceholder: 'Please select auto start player count',
    autoStartPeopleVerify: 'Please select auto start player count!',
    minSubstitution: 'Minimum Buy-in',
    minSubstitutionPlaceholder: 'Please select minimum buy-in',
    minSubstitutionVerify: 'Please select minimum buy-in!',
    currentGambleTable: 'Current Table',
    currentGambleTablePlaceholder: 'Please select current table',
    currentGambleTableVerify: 'Please select current table!',
    dataType: 'Data Type',
    dataTypePlaceholder: 'Please select data type',
    dataTypeVerify: 'Please select data type!',
    date: 'Date',
    datePlaceholder: 'Please select date',
    dateVerify: 'Please select date!',
    competition: 'Tournament',
    competitionPlaceholder: 'Please select tournament',
    competitionVerify: 'Please select tournament!',
    club: 'Club',
    clubPlaceholder: 'Please select club',
    clubVerify: 'Please select club!',
    accountType: 'Account Type',
    accountTypePlaceholder: 'Please select account type',
    accountTypeVerify: 'Please select account type!',
    matchCnfig: 'Tournament Configuration',
    matchCnfigPlaceholder: 'Please select tournament configuration',
    matchCnfigVerify: 'Please select tournament configuration!',
    addonChip: 'Addon Chips',
    addonChipPlaceholder: 'Please select addon chips',
    addonChipVerify: 'Please select addon chips!',
    nextMatch: 'Next Round Match',
    nextMatchPlaceholder: 'Please select next round match',
    nextMatchVerify: 'Please select next round match!',
    ticket: 'Ticket',
    ticketPlaceholder: 'Please select addon ticket',
    ticketVerify: 'Please select addon ticket!',
    award: 'award',
    awardPlaceholder: 'Please set rewards',
    awardVerify: 'Please set rewards!',
    awardPlaceholder1: 'Please set the reward for the {} th place',
    awardVerify1: 'Please set the reward for the {} th place!',
    expirationTime: 'Expiration time',
    expirationTimePlaceholder: 'Please select expiration time',
    expirationTimeVerify: 'Please select expiration time!',
    matchType: 'Competition type',
    matchTypePlaceholder: 'Please select competition type',
    matchTypeVerify: 'Please select competition type!',
    supportMatch: 'Support the competition',
    supportMatchPlaceholder: 'Please select support the competition',
    supportMatchVerify: 'Please select support the competition!',
    managementUnion: 'Management union',
    managementUnionPlaceholder: 'Please select management union',
    managementUnionVerify: 'Please select management union!',
    proxyPlatformTokenType: 'Proxy platform token type',
    proxyPlatformTokenTypePlaceholder: 'Please select proxy platform token type',
    proxyPlatformTokenTypeVerify: 'Please select proxy platform token type!',
    walletType: 'Wallet type',
    walletTypePlaceholder: 'Please select the wallet type',
    walletTypeVerify: 'Please select the wallet type!',
    gameMatchCnfig: '{} configuration',
    gameMatchCnfigPlaceholder: 'Please select the {} configuration',
    gameMatchCnfigVerify: 'Please select the {} configuration!',
    taskMatchCnfig: 'Task configuration',
    taskMatchCnfigPlaceholder: 'Please select the task configuration',
    taskMatchCnfigVerify: 'Please select the task configuration!',
    showType: 'Display type',
    showTypePlaceholder: 'Please select the display type',
    showTypeVerify: 'Please select the display type!',
    displayCurrency: "Display currency",
    displayCurrencyPlaceholder: "Please select to display the currency",
    displayCurrencyVerify: "Please select to display the currency!",
    activityType: "Activity type",
    activityTypePlaceholder: "Please select the activity type",
    activityTypeVerify: "Please select the activity type!",

    // 后缀
    levelFix: '(Big Blind / Ante / Base Bet)',
    initChipFix: '(x Starting Chips)',
    levelsuFix: '(Level)',
    ipWhiteListFix: "(Separate multiple IPs with ',', max 20)",
    everyDayTimeFix: '(What time each day)',
    minuteFix: '(Minutes)',
    initChipFix: '(x Initial Chips)',
    tenMultipleFix: '(Multiple of 10)',
    counterDeductionFix: '(Points will be pre-deducted from counter)',

    // 其他
    unionTitle: 'Alliance Management System',
    union: 'Alliance',
    unionVip: 'Super Admin',
    unionAdmin: 'Alliance Administrator',
    unionAdminService: 'Alliance Support',
    unionAdminAccount: 'Alliance Viewer',
    kpokerUnionTitle: 'Kpoker Alliance Management System',
    kpokerUnion: 'Kpoker Alliance',
    kpokerUnionVip: 'Super Admin',
    kpokerUnionAdmin: 'Kpoker Alliance Administrator',
    kpokerUnionAdminService: 'Kpoker Alliance Support',
    kpokerUnionAdminAccount: 'Kpoker Alliance Viewer',
    superUnionTitle: 'Super Union Management System',
    superUnion: 'Super Union',
    superUnionVip: 'Super Admin',
    superUnionAdmin: 'Super Union Administrator',
    superUnionAdminService: 'Super Union Support',
    superUnionAdminAccount: 'Super Union Viewer',
    superUnionAdminHouTong: 'Super Alliance Post-unification',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    edit: 'Edit',
    save: 'Save',
    search: 'Search',
    submit: 'Submit',
    update: 'Update',
    view: 'View',
    add: 'Add',
    loginTitle: 'Super Union / Alliance Management System',
    login: 'Login',
    lastStep: 'Previous Step',
    phoneAccountLogin: 'Mobile / account Login',
    emailAccountLogin: 'Email Login',
    switchAccount: 'Switch Account',
    logout: 'Logout',
    query: 'Query',
    reset: 'Reset',
    exportExcel: 'Export to Excel',
    endTime: 'End Time',
    updateTime: 'Update Time',
    addTime: 'Add Time',
    registerTime: 'Registration Time',
    lastLoginTime: 'Last Login Time',
    lastPlayCardTime: 'Last Play Time',
    operation: 'Operation',
    counterPoint: 'Counter Points',
    counterDiamond: 'Counter Diamonds',
    gain: 'Profit',
    pvpProfitSum: 'Player PVP Game Profit/Loss',
    insProfitSum: 'Player Insurance Profit/Loss',
    cbProfitSum: 'Player Cowboy Profit/Loss',
    gamePepoleNumber: 'Game Player Count',
    matchSum: 'Game Count',
    player: 'Player',
    lower: 'Downline',
    data: 'Data',
    balance: 'Balance',
    today: 'Today',
    thisWeek: 'This Week',
    lastWeek: 'Last Week',
    historyTotal: 'Historical Total',
    totalIncome: 'Total Revenue',
    insurance: 'Insurance',
    accountName: 'Account Nickname',
    addAccount: 'Add Account',
    editAccount: 'Edit Account',
    intergralBalance: 'Points Balance',
    type: 'Type',
    remark: 'Remark',
    distributionSource: 'Distribution Source',
    distributionAmount: 'Distribution Amount',
    amountLimit: 'Amount',
    superProxy: 'Super Agent',
    superProxyId: 'Super Agent ID',
    superProxyName: 'Super Agent Nickname',
    oneProxy: 'Level 1 Agent',
    oneProxyId: 'Level 1 Agent ID',
    oneProxyName: 'Level 1 Agent Nickname',
    twoProxy: 'Level 2 Agent',
    twoProxyId: 'Level 2 Agent ID',
    twoProxyName: 'Level 2 Agent Nickname',
    threeProxy: 'Level 3 Agent',
    threeProxyId: 'Level 3 Agent ID',
    threeProxyName: 'Level 3 Agent Nickname',
    fourProxy: 'Level 4 Agent',
    fourProxyId: 'Level 4 Agent ID',
    fourProxyName: 'Level 4 Agent Nickname',
    diamondAmount: 'Diamond Amount',
    intergralAmount: 'Point Amount',
    totalCusome: 'Total Consumption',
    cusomeAmount: 'Consumption Amount',
    cusomeOrigin: 'Consumption Source',
    gambleId: 'Game Round ID',
    level: 'Level',
    startCosume: 'Game Start Consumption',
    exchangeIntergral: 'Exchange Points',
    distribution: 'Distribution',
    importMatchConfig: 'Import Tournament Configuration',
    applyPeopleNumber: 'Number of Registrants',
    applyPeopleTime: 'Registration Entries',
    rebuyHand: 'Rebuy Hands',
    addonHand: 'Addon Hands',
    enterFee: 'Entry Fee',
    bonusPayment: 'Prize Distribution',
    profit: 'Profit/Loss',
    winnerPeople: 'In-the-Money Players',
    serviceRatio: 'Service Fee Ratio',
    addonTime: 'Addon Count',
    matchDurationTime: 'Match Duration',
    createTime: 'Creation Time',
    isClone: 'Clone Match',
    isRoomCowboy: 'In-Room Cowboy',
    disableSimulator: 'Disable Emulator',
    satelliteGames: 'Satellite Match',
    currentBlind: 'Current Blinds',
    blindTimeStart: 'Blind Increase Time',
    endApplyLevel: 'Registration Deadline Level',
    nlh: 'NLH',
    plo: 'PLO',
    aof: 'AOF',
    six: '6+',
    mtt: 'MTT',
    ofc: 'OFC',
    cowboy: 'COWBOY',
    nhlInsurance: 'Insurance_NLH',
    ploInsurance: 'Insurance_PLO',
    aofInsurance: 'Insurance_AOF',
    sixInsurance: 'Insurance_6+',
    mttInsurance: 'Insurance_MTT',
    ofcInsurance: 'Insurance_OFC',
    cowboyInsurance: 'Insurance_COWBOY',
    nlhFee: 'Service Fee_NLH',
    ploFee: 'Service Fee_PLO',
    aofFee: 'Service Fee_AOF',
    sixFee: 'Service Fee_6+',
    mttFee: 'Service Fee_MTT',
    ofcFee: 'Service Fee_OFC',
    cowboyFee: 'Service Fee_COWBOY',
    nlhProfit: 'Player Profit/Loss_NLH',
    ploProfit: 'Player Profit/Loss_PLO',
    aofProfit: 'Player Profit/Loss_AOF',
    sixProfit: 'Player Profit/Loss_6+',
    mttProfit: 'Player Profit/Loss_MTT',
    ofcProfit: 'Player Profit/Loss_OFC',
    cowboyProfit: 'Cowboy Profit/Loss_COWBOY',
    nlhDeductFee: 'Reporting Deduction_Service Fee_NLH',
    ploDeductFee: 'Reporting Deduction_Service Fee_PLO',
    aofDeductFee: 'Reporting Deduction_Service Fee_AOF',
    sixDeductFee: 'Reporting Deduction_Service Fee_6+',
    mttDeductFee: 'Reporting Deduction_Service Fee_MTT',
    ofcDeductFee: 'Reporting Deduction_Service Fee_OFC',
    cowboyDeductFee: 'Reporting Deduction_Service Fee_COWBOY',
    nlhDeductInsurance: 'Reporting Deduction_Insurance_NLH',
    ploDeductInsurance: 'Reporting Deduction_Insurance_PLO',
    ofcDeductInsurance: 'Reporting Deduction_Insurance_OFC',
    sixDeductInsurance: 'Reporting Deduction_Insurance_6+',
    mttDeductInsurance: 'Reporting Deduction_Insurance_MTT',
    aofDeductInsurance: 'Reporting Deduction_Insurance_AOF',
    cowboyDeductInsurance: 'Reporting Deduction_Insurance_COWBOY',
    openNumberStatistics: 'Game Start Count_NLH/6+/PLO/OFC/MTT/CB/AOF',
    joinPeopleNumberStatistics: 'Participants_NLH/6+/PLO/OFC/MTT/CB/AOF',
    handNumberStatistics: 'Hands Count_NLH/6+/PLO/OFC/MTT/CB/AOF',
    playerProfitStatistics: 'Player Profit/Loss_NLH/6+/PLO/OFC/MTT/CB/AOF',
    serviceFeeStatistics: 'Service Fee_NLH/6+/PLO/OFC/MTT/CB/AOF',
    insuranceStatistics: 'Insurance_NLH/6+/PLO/OFC/MTT/CB/AOF',
    insuranceBuyInStatistics: 'Insurance Buy-in Detail_NLH/6+/PLO/OFC/MTT/CB/AOF',
    joinTableNumberStatistics: 'Participation Rounds_NLH/6+/PLO/OFC/MTT/CB/AOF',
    profitStatistics: 'Profit_NLH/6+/PLO/OFC/MTT/CB/AOF',
    competitionType: 'Tournament Type',
    matchApplyFee: 'Registration/Service Fee (Tournament)',
    rebootApplyFee: 'Registration/Service Fee (Re-entry)',
    repurchaseApplyFee: 'Registration/Service Fee (Rebuy)',
    buyMoreApplyFee: 'Registration/Service Fee (Addon)',
    seatNumber: 'Seat Count',
    totalSeatNumber: 'Total Tables',
    applyNumber: 'Number of Registrations',
    rebootNumber: 'Rebuy Players Count',
    rebootTime: 'Rebuy Times',
    repurchaseNumber: 'Re-entry Players Count',
    repurchaseTime: 'Re-entry Times',
    buyMoreTime: 'Addon Times',
    totalApplyFee: 'Total Entry Fee',
    totalServiceFee: 'Total Service Fee',
    ticketApply: 'Number of ticket registrations',
    prizePool: 'Prize Pool',
    matchSeparate: 'Tournament Revenue Share',
    matchIncome: 'Tournament Revenue',
    order: 'Ranking',
    prizeTicketNumber: 'Rewarded Ticket Count',
    chipNumber: 'Chip Count',
    matchTime: 'Participation Count',
    apply: 'Registration',
    repurchase: 'Re-entry',
    reboot: 'Rebuy',
    buyMore: 'Addon',
    satelliteName: 'Satellite Match Name',
    mainMatchName: 'Main Event Name',
    statusUpdateTime: 'Status Update Time',
    superPlayerId: 'Upline Player ID',
    superPlayerName: 'Upline Player Nickname',
    lowerCounterTotalIntergral: 'Downline Total Counter Points',
    lowerProxyNumber: 'Downline Agent Count',
    lowerPlayerNumber: 'Downline Player Count',
    handNumber: 'Hands Count',
    gameProfit: 'Game Profit/Loss',
    serviceFeeContribution: 'Service Fee Contribution',
    insuranceContribution: 'Insurance Contribution',
    insuranceInvestmentAmount: 'Insurance Bet Amount',
    cowboyContribution: 'Cowboy Contribution',
    cowboyBettingAmount: 'Cowboy Bet Amount',
    loginTime: 'Login Time',
    clientVersion: 'Client Version',
    channelNumber: 'Sub-channel Code',
    networkType: 'Network Type',
    systemYype: 'System Type',
    unitType: 'Device Model',
    loginIp: 'Login IP',
    imei: 'Device IMEI',
    macAddress: 'Client MAC Address',
    openRole: 'Game Start Role',
    squidGame: 'Squid Game',
    openInsurance: 'Insurance Enabled',
    profit: 'Profit/Loss',
    insuranceProfit: 'Insurance Profit/Loss',
    buyIn: 'Buy-in',
    insureTimes: 'Insurance Count',
    sumInsured: 'Insurance Amount',
    betAmount: 'Bet Slip Amount',
    rank: 'Rank',
    belongUnionId: 'Affiliated Alliance ID',
    belongUnionName: 'Affiliated Alliance Name',
    belongClubId: 'Affiliated Club Name',
    belongClubName: 'Belonging Club Name',
    playerDiamnd: 'Player Diamonds',
    totalProfit: 'Total Profit/Loss',
    totalInsurance: 'Total Insurance',
    joinTableNumber: 'Participated Rounds',
    handCardNumber: 'Hands Count',
    playerProfit: 'Player Profit/Loss',
    cowboysProfit: 'Cowboy Profit/Loss',
    configId: 'Configuration ID',
    autoUnloadCode: 'Auto Chip Removal',
    colorPool: '27 Pool',
    bombMode: 'Bomb Mode',
    entryPoolStandard: 'Entry Criteria',
    lame: 'Wild Card',
    insuranceMode: 'Insurance Mode',
    blind: 'Blind Compensation',
    straddle: 'Forced Straddle',
    showHands: 'Forced Showdown',
    openCard: 'Sequential Showdown',
    randomSeat: 'Random Seating',
    ipAndGpsLimit: 'IP & GPS Restriction',
    closeChat: 'Disable Chat',
    autoRoomReconstruction: 'Auto Room Rebuild',
    squidDisabled: 'Squid Mode Temporarily Unavailable',
    defaultTableName: 'Default Game Round Name',
    playMethod: 'Game Mode',
    todayOpenTable: 'Tables Opened Today',
    gambleProgress: 'Tables In Progress',
    openTable: 'Started Empty Tables',
    notBeginTable: 'Unstarted Tables',
    isAutoOpenTable: 'Auto Table Launch',
    gambleOpenTime: 'Game Round Start Time',
    gamble: 'Game Round',
    totalHand: 'Total Hands Played',
    gambleStatus: 'Game Round Status',
    currentPeopleNumber: 'Active Players / Seats',
    gambleType: 'Game Round Mode',
    inClub: 'Associated Club',
    inUnion: 'Associated Alliance',
    inSuperUnion: 'Associated Super Union',
    bought: 'Buy-in Completed',
    poolEntryRate: 'VPIP (Voluntarily Put in Pot)',
    gameNickname: 'Game Nickname',
    betAmount: 'Bet Amount',
    totalBuyIn: 'Total Buy-in',
    insuranceBuyamount: 'Insurance Purchase Amount',
    serviceFeesPercentage: 'Service Fee Share Ratio',
    insurancePercentage: 'Insurance Share Ratio',
    joinNumber: 'Number of Participants',
    propConsume: 'Item Consumption',
    palyerTotalProfit: 'Total Player Profit/Loss',
    cowboyBetAmount: 'Cowboy Bet Count',
    activityBouns: 'Event Prize',
    activityCost: "Event Cost",
    propsConsumeIntergral: 'Item Consumption Points',
    cowboysProportion: 'Cowboy Share Ratio',
    totalProportion: 'Total Share',
    totalGaveIn: 'Total Reporting',
    palyerNumber: 'Number of Players',
    allowCreateTable: 'Allow Game Round Creation',
    activityId: 'Event ID',
    currentRound: 'Current Round',
    totalRound: 'Total Rounds',
    singlePrize: 'Reward per Round',
    totalPrize: 'Total Reward',
    alreadyWinnPeople: 'Winners Count',
    alreadyPrize: 'Award Received',
    round: 'Round',
    currentRoundEndTime: 'End Time of This Round',
    winPrizeTime: 'Winning Time',
    winPrizePlayerId: 'Winning Player ID',
    winrizePlayerName: 'Winning Player Nickname',
    cardType: 'Hand Type',
    poster: 'Poster',
    clubOwnerId: 'Club Owner ID',
    clubOwnerName: 'Club Owner Nickname',
    joinUnionTime: 'Alliance Join Time',
    proxyAmount: 'Agent Count',
    cowboyBetAmount: 'Cowboy Bet Count',
    luckycard: 'Lucky Card',
    jackpot: 'Jackpot',
    ipLoginCount: 'Same IP Login Count',
    equipmentLoginCount: 'Same Device Login Count',
    tableCount: 'Same Table Count',
    tableOdd: 'Same Table Rate',
    poolCount: 'Same Pot Count',
    poolOdd: 'Same Pot Rate',
    poolBetCount: 'Same Pot Re-raise Count',
    dubiousGambleCount: 'Suspicious Game Rounds Count',
    playerOneName: 'Player 1 Nickname',
    playerTwoName: 'Player 2 Nickname',
    unionOwnerName: 'Alliance Owner Nickname',
    joinSuperUnionTime: 'Super Union Join Time',
    clubNumber: 'Number of Clubs',
    allowCreateFreeMatch: 'Allow Free/Guaranteed Tournament Creation',
    clubApplicationRecord: 'Club Application Records',
    clubPeopleNumber: 'Club Members Count',
    applicationTime: 'Application Time',
    messageContent: 'Message Content',
    serviceFeeZC: 'Service Fee Share',
    insuranceZC: 'Insurance Share',
    cowboyZC: 'Cowboy Share',
    currentPrizePool: 'Current Jackpot',
    currentLunckyCard: 'Current Lucky Card',
    rechargePrizePool: 'Top-up Prize Pool',
    userDataQuery: 'User Data Screening',
    hitGambleStartDate: 'Hit Game Round Start Date',
    hitDate: 'Hit Time',
    handId: 'Hand ID',
    winAmount: 'Winning Amount',
    thatTimeAward: 'The prize pool at that time',
    reissue: 'Reissue',
    noReissue: 'No Reissue',
    activityDescription: 'Event Description',
    activityDescription1: '1. The system randomly selects two cards daily. If the player wins with those two cards (in PLO they must be used in final hand), they receive bonus rewards.',
    activityDescription2: '2. The prize pool is drawn from pots over 10BB.',
    activityDescription3: '3. Players receive rewards after completing required rounds.',
    serviceFeeAndBonus: 'Service Fee & Prize',
    blindBet: 'Blinds',
    prizeCount: 'Reward (AOF Count ×3, PLO count x3)',
    prizeTwoCount: '2 Times',
    prizeTenCount: '5 Times',
    prizeType3: '10 Times',
    activitySwitch: 'Event Toggle',
    functionDescription: 'Feature Description',
    winCondition: 'Winning Conditions',
    winCondition1: '1. Game Types: NLH, PLO4, PLO5',
    winCondition2: '2. The loser must have the minimum qualifying hand',
    winCondition3: '3. At least 4 players dealt, valid pot ≥ 10BB',
    winCondition4: '4. Final hand must include 2 hole cards. Full house needs one A, Four-of-a-kind must be from hand pair.',
    minHandCard: 'Minimum Qualifying Hand',
    handCardType1: 'NLH: AAAJJ',
    handCardType2: 'PLO4: KKKK2',
    handCardType3: 'PLO5: 45678 Straight Flush',
    serviceFeeAndBonusRatio: 'Service Fee & Prize Ratio',
    underdog: 'Loser',
    winner: 'Winner',
    other: 'Others',
    createPoster: 'Create Poster',
    suggestHeightWidth: 'Suggested Size: 950px × 1500px',
    suggestSize: 'Suggested Size: Within 1MB',
    createUnion: 'Create Alliance',
    currentSuperUnionServiceFeeContribution: 'Current Super Union Service Fee Contribution Ratio',
    risk: 'Risk',
    sendIntergral: 'Grant Points',
    recycleIntergral: 'Reclaim Points',
    sendDiamond: 'Grant Diamonds',
    recycleDiamond: 'Reclaim Diamonds',
    sendChip: 'Grant Chips',
    recycleChip: 'Reclaim Chips',
    editProportion: 'Edit Share Ratio',
    availableProportion: 'Available Share Ratio',
    unionOwn: 'Held by Alliance',
    clubOwn: 'Held by Club',
    superProxyOwn: 'Held by Super Agent',
    proxyOwn: 'Held by Agent',
    palyerOwn: 'Held by Player',
    shieldGamble: 'Game Round Blocked',
    bbLevel1: 'Micro Stakes (BB: < 5)',
    bbLevel2: 'Low Stakes (BB: 5 - 10)',
    bbLevel3: 'Mid Stakes (BB: 20 - 100)',
    bbLevel4: 'High Stakes (BB: 100+)',
    anteLevel1: 'Micro Stakes (Ante: < 5)',
    anteLevel2: 'Low Stakes (Ante: 5 - 10)',
    anteLevel3: 'Mid Stakes (Ante: 20 - 100)',
    anteLevel4: 'High Stakes (Ante: 100+)',
    scoreLevel1: 'Micro Stakes (Base: < 5)',
    scoreLevel2: 'Low Stakes (Base: 5 - 10)',
    scoreLevel3: 'Mid Stakes (Base: 20 - 100)',
    scoreLevel4: 'High Stakes (Base: 100+)',
    applyLevel1: 'Micro Stakes (Entry Fee: < 5)',
    applyLevel2: 'Low Stakes (Entry Fee: 5 - 10)',
    applyLevel3: 'Mid Stakes (Entry Fee: 20 - 100)',
    applyLevel4: 'High Stakes (Entry Fee: 100+)',
    feeMatch: 'Free Tournament',
    intergralRecord: 'Point Records',
    clubInfo: 'Club Info',
    dataRecord: 'Data Records',
    loginRecord: 'Login Records',
    proxyData: 'Agent Data',
    gameData: 'Game Data',
    yesterday: 'Yesterday',
    sevenDay: 'Last 7 Days',
    addConfig: 'Add {} Configuration',
    importConfig: 'Import {} Configuration',
    pot: 'Pot',
    playerNumber: 'Player Count',
    handCard: 'Hole Cards',
    gambleStatistics: 'Game Round Statistics',
    recordDetail: 'Game History Details',
    playerList: 'Player List',
    setEmptyTableCard: 'Set Empty Tables',
    createGambleTableRound: 'Create Game Round',
    publish: 'Publish',
    dissolve: 'Dissolve',
    createMatch: 'Create Tournament',
    monday: 'Monday',
    tuesday: 'Thursday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    eventSummary: 'Tournament Summary',
    accountInfo: 'Account Information',
    intergralConsumeRecord: 'Point Consumption Transaction Flow',
    openConsumeRecord: 'Game Start Consumption Transaction Flow',
    exchangeConsumeRecord: 'Exchange Points Transaction Flow',
    distributionRecord: 'Distribution Transaction Flow',
    createHighHandCard: 'Create HighHandCard',
    activityRecord: 'Event Records',
    offLine: 'Offline',
    freeLimitedTime: 'Limited-Time Free',
    aggregate: 'Total',
    agree: 'Approve',
    refuse: 'Reject',
    createProxy: 'Create Agent',
    accessConfig: 'Integration Configuration',
    copyAndSave: 'Copy and Save',
    proxyInformation: 'Agent Profile',
    initPassword: 'Initial Password',
    systemCode: 'System Code',
    commonCard: 'Community Cards',
    winSquid: 'Get Squid',
    squidResult: 'Squid Settlement',
    singleMode: 'Single Mode',
    normalMode: 'Standard Mode',
    crazyModel: 'Crazy Mode',
    remoteHolder: 'Backhand / Behind',
    buy: 'Purchase',
    compensate: 'Payout',
    odds: 'Odds',
    transferCards: 'Turn (Poker)',
    drawCards: 'Tie / Split Pot',
    passivePurchase: 'Passive Purchase',
    activePurchase: 'Active Purchase',
    firstRound: 'First Round',
    twoRound: 'Second Round',
    threeRound: 'Third Round',
    fourRound: 'Fourth Round',
    fiveRound: 'Fifth Round',
    fold: 'Fold',
    owner: 'Owner',
    admin: 'Manager',
    member: 'Member',
    tenPercent: '10%',
    fifteenPercent: '15%',
    twentyPercent: '20%',
    thirtyPercent: '30%',
    fixedBonus: 'Fixed Prize',
    notPublish: 'Unpublished',
    notStart: 'Not Started',
    process: 'In Progress',
    finished: 'Finished',
    dissolved: 'Dissolved',
    published: 'Published',
    deleted: 'Deleted',
    offline: 'Offline',
    pendingReview: 'Pending review',
    systemReissue: 'System reissue',
    systemNotReissue: 'System No reissue',
    reviewedAndReissued: 'Reviewed - Reissued',
    reviewedAndNotReissued: 'Reviewed - No reissue',
    standard: 'Standard',
    speediness: 'Fast',
    deepChip: 'Deep Stack',
    manualPublish: 'Manual Publish',
    autoPublish: 'Auto Publish',
    everyDayPublish: 'Daily Scheduled Publish',
    everyWeekPublish: 'Weekly Scheduled Publish',
    all: 'All',
    tablePlayers: 'Players at Table',
    oneself: 'Self Only',
    bloodBattleMode: 'Blood Battle Mode',
    bloodFlowsInOut: 'Blood-In Blood-Out',
    meantime: 'Simultaneous',
    inOrder: 'Sequential',
    minute: 'Minutes',
    playPeople: 'Active Player Count',
    clubTableRound: 'Club Game',
    unionTableRound: 'Alliance Game',
    superUnionTableRound: 'Super Union Game',
    createOwnerUid: 'Creator UID',
    summarize: 'Summary',
    playerChip: 'Player Chips',
    total: 'Total',
    item: 'Entries',
    consumeType: 'Consumption Type',
    handCardId: 'Hand ID',
    hint: 'Hint / Tip',
    everyHoursConsumeDiamond: 'Hourly Diamond Consumption',
    originalPrice: 'Original Price',
    currentPrice: 'Current Price',
    superUnionServiceContributionProportion: 'Parent Super Union Service Fee Contribution Ratio',
    unionServiceContributionProportion: 'Current Alliance Service Fee Contribution Ratio',
    editWhiteList: 'Edit IP Whitelist',
    proxySystemAddress: 'Agent Backend URL',
    apiAddress: 'API URL',
    yes: 'Yes',
    no: 'No',
    lossSetting: 'Loss Setting',
    unionInfo: 'Alliance Information',
    remainingQuota: " (Remaining: {})",
    dubiousGamble: 'Suspicious Game Round',
    game: 'Game',
    createHandRank: 'Create Hand Count Ranking',
    createTask: 'Create a task',
    importTask: 'Import task',
    editOrder: 'Edit sorting',
    recharge: 'Top-up',
    onlineAccessDocument: 'Online Integration Docs',
    pleaseSaveAccountPassword: 'Please Save Account & Password',
    clubAccountPassword: 'Club Account & Password',
    playerData: 'Player Data',
    gambleDetail: 'Game Round Details',
    handDetail: 'Hand Details',
    endGamble: 'End Game Round',
    started: 'Started',
    hand: 'Hands',
    person: 'People / Players',
    count: 'Times',
    hour: 'Hour(s)',
    second: 'Second(s)',
    unlimited: 'No Limit',
    double: 'Multiplier',
    gambleTable: 'Table',
    serviceFeeSharingRatio: 'Service Fee Share Ratio',
    insuranceSharingRatio: 'Insurance Share Ratio',
    cowboySharingRatio: 'Cowboy Share Ratio',
    cowboyMode: 'Cowboy Mode',
    diamondLog: 'Diamond Records',
    playerInfo: 'Player Information',
    lowerProxy: 'Downline Agent',
    lowerPlayer: 'Downline Player',
    proportionData: 'Share Ratio Data',
    pageNotExist: 'Sorry, the page you visited does not exist.',
    backHomepage: 'Return to Homepage',
    cancelled: 'Logged Out',
    writeOff: 'Logout',
    createTickets: 'Create a ticket',
    editTickets: 'Edit a ticket',
    editMatch: 'Editing Competition',
    rewardsNumber: 'Rewarded Player Count',
    matchStatistics: 'Tournament Statistics',
    autoRebuy: 'Auto Rebuy',
    giveUpRebuy: 'Decline Rebuy',
    autoAllin: 'Auto All-in',
    autoFold: 'Auto Fold',
    aiPlayCard: 'AI Playing',
    playingRobot: 'Active Bots',
    participated: 'Registered',
    cancelApply: 'Cancel Registration',
    batchApply: 'Batch Registration',
    applyTool: 'Registration Tool',
    refresh: 'Refresh',
    dataStatistics: 'Data Statistics',
    testTool: 'Test Tool',
    currentUnion: 'Current Alliance',
    currentSuperUnion: 'Current Super Union',
    administrator: 'Administrator',
    service: 'Support',
    reconciliation: 'Viewer',
    postUnification: 'Post-unification',
    consumeIntergral: 'Consumed Points',
    createMttMatch: 'Create MTT Tournament',
    editMttMatch: 'Edit MTT Tournament',
    selectPageExport: 'Select Page Export',
    discardedHandNumber: 'Folded Hands',
    notServiceFeeHandNumber: 'No Service Fee Hands',
    betBoolHandNumber: 'Pot < 10BB Hands',
    enterBollHandNumber: 'Entry Pool Hands',
    drawHandNumber: 'Flop Hands',
    notBetBoolHandNumber: 'No Pot Fee Hands',
    twoPeopleGambleHandNumber: '2-Player Game Hands',
    threePeopleGambleHandNumber: '3-Player Game Hands',
    notLuckfeeHandNumber: 'No Luck Fee Games',
    totalContributeServiceFee: 'Total Service Fee Contribution',
    everyHandServiceFeeBb: 'Service Fee BB per Hand',
    diamondBalance: 'Diamond Balance',
    reconciliationDate: 'Reconciliation Time',
    reconciliationStartDate: 'Reconciliation Start Time',
    reconciliationEndDate: 'Reconciliation End Time',
    exportEndPageTooLargeVerify: 'The end page must be larger than the start page!',
    cowboyText: 'Cowboy',
    operateRecord: 'Operation Record',
    counterDiamondRecord: 'Counter Diamond Record',
    autoAddon: 'Auto Addon',
    giveUpAddon: 'Give Up Addon',
    registerChannel: 'Registration Channel',
    exportDataRecord: 'Export Data Record',
    hangMode: 'Hang Mode',
    hangModeTips: 'Current Ante and buy-in range are "hang" values. Dragging the buy-in range can automatically turn off the "hang" switch',
    exportLoaddingMessage: 'Exporting, please wait...',
    exportGambleRecord: 'Export Game Record',
    day: 'Day',
    page: 'Page',
    apiPropCusome: 'API Props Consumption',
    apiPropCusomeGiveIn: 'API Props Consumption Payment',
    apiPropCusomeContribution: 'API Props Consumption Contribution',
    publishMinuteLimit: 'The minutes cannot exceed 7 days',
    palyingType1: 'Squid',
    palyingType2: 'Ramming field',
    palyingType3: 'Normal',
    palyingType3Suffix: ' (Except for squid and ramming fields)',
    basicInfo: 'basic information',
    rewardConfig: 'Reward configuration',
    winnerPlayer: 'Winning player',
    notSeriesMatch: 'Non-series',
    seriesMatch: 'Series',
    proportionRecord: 'Proportional Recording',
    proportionConfig: 'Proportional Allocation',
    configRecord: 'Configuration Record',
    effectiveRecord: 'Effective record',
    publishRecord: 'Release record',
    allVersion: 'All',
    majorVersion: 'Major Version',
    apiVersion: 'Api Version',
    GameIntegral: 'Game Points',
    claimPeople: 'Number of recipients (weight ranking)',
    intergralSendTotalNumber: 'Total amount of points distributed',
    ticketSendNumber: 'The number of tickets issued',
    claimTimes: 'Claim times',
    perCapitaFrequency: 'Per capita frequency',
    perCapitaAmount: 'Per capita amount',
    playCardPepole: 'The number of people playing cards',
    claimRate: 'Claim rate',
    operationPersonId: 'Operator UID',
    operationPersonName: 'Operator Name',
    operationPersonRole: 'Operator Role',
    operationType: 'Operation Type',
    operationDetail: 'Operation Details',
    operationedPlayerId: 'Operated Player ID',
    operationedPlayerName: 'Operated Player Name',
    proxyInfo: 'Agent Information',
    derivativeInitiatorName: 'Reverse Scoring Initiator Nickname',
    derivativeReceiverName: 'Profiteer Receiver Nickname',
    invertIntegral: 'Reverse Points',
    invertBlindNumber: 'Reverse Blinds',
    betPeopleNumber: 'Number of Bettors',
    cardGameTime: 'Game Time',
    exceptionType: 'Exception Type',
    transferWallet: 'Transfer Wallet',
    singleWallet: 'Single Wallet',
    proxyIdSuffix: '(Proxy unique identifier, game system generates unique bound api interface parameters)',
    proxySuffix: '(Used for background display to distinguish agents)',
    zh: 'Chinese (Traditional)',
    en: 'English',
    th: 'Thai',
    vn: 'Vietnamese',
    id: 'Indonesian',
    pt: 'Portuguese',
    ko: 'Korean',
    spa: 'Spanish',
    lao: 'Lao',
    my: 'Burmese',
    jp: 'Japanese',
    bn: 'Bengali',
    rs: 'Russian',
    tr: 'Turkish',
    changePassword: "Change Password",
    changePasswordSuccess: "The modification was successful. Please log in again",
    myIncome: "My Earnings",
    luckcardAndJackpot: "LC&JP",
    luckcardAndJackpotProfit: "LC&JP Profit",
    income: "Earnings",
    editLossLimit: "Editorial loss limit",
    distributed: "Distributed",
    notDistributed: "Not Distributed",
    serverDate: "Server Time",
}